<template>
  <div id="About">
    <div id="About-body">
      <div class="About-title">
        <img src="../assets/images/About/About-img.png"/>
        <h1>关于我们</h1>
      </div>
      <p>上海未谷信息技术有限公司，成立于2015年4月，是一家关注0-18岁儿童青少年身体健康数据的互联网科技公司。<br><br></p>
      <p>旗下主要产品包含量表评估系统和儿童健康管理系统，我们主要为流行病学研究提供的解决方案，覆盖项目设计、项目过程的质量管控、项目完成后数据分析全部环节，可以助力您的调研项目的科学制定和有效实施。</p>
      <p>公司提供全球科研领域使用最广泛的身体活动检测仪ActiGraph设备、AMI各种睡眠监测仪器以及相关软件产品的购买或租赁、软件使用培训、现场实施等服务，为您的研究项目提供全方位的技术支持。<br><br></p>
      <p>团队在过去的2年内，已陆续为上海市儿童早期健康服务体系、中国儿童青少年体育健身指数、中国儿童青少年身体活动指南等提供专业的数据服务。</p>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.changStyle();
  },
  methods: {
    changStyle() {
      var serviceA=document.getElementById('serviceA');
      serviceA.style.color='#000';
      serviceA.style['font-weight'] = 'normal';
      serviceA.onmouseover=function(){
        serviceA.style.color='#74B6EC';
      }
      serviceA.onmouseout=function(){
        serviceA.style.color='#000';
      }
      var solutionA=document.getElementById('solutionA');
      solutionA.style.color='#000';
      solutionA.style['font-weight'] = 'normal';
      solutionA.onmouseover=function(){
        solutionA.style.color='#74B6EC';
      }
      solutionA.onmouseout=function(){
        solutionA.style.color='#000';
      }
    }
  }
}
</script>

<style lang="scss">

#About-body{
  display: inline-block;
  padding-bottom: 60px;
}
#About-body .About-title{
  text-align: left;
  width: 554px;
  margin-top: 60px;
  margin-bottom: 28px;
}
#About-body .About-title img{
  display: inline-block;
  margin-top: 8px;
  vertical-align:middle;
}
#About-body .About-title h1{
  font-size: 30px;
  margin-left: 10px;
  color: #282828;
  vertical-align:middle;
  display: inline-block;
}
#About-body p{
  width: 554px;
  text-indent:2em;
  line-height: 36px;
  font-size: 18px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue